const style = (theme): any => ({
    // The palette sits near the top of the viewport, not vertically centered
    scrollPaper: {
        alignItems: 'flex-start',
    },
    paper: {
        marginTop: '10vh',
        borderRadius: 10,
        overflow: 'hidden',
    },
    searchRow: {
        display: 'flex',
        alignItems: 'center',
        padding: '4px 16px',
        borderBottom: `1px solid ${theme.palette.colors.table.separator}`,
    },
    searchIcon: {
        color: theme.palette.colors.greyDark,
        marginRight: 12,
    },
    input: {
        fontSize: 18,
    },
    progress: {
        height: 2,
    },
    progressPlaceholder: {
        height: 2,
    },
    results: {
        maxHeight: '55vh',
        overflowY: 'auto',
        padding: 0,
    },
    groupLabel: {
        display: 'flex',
        alignItems: 'center',
        padding: '10px 16px 4px',
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: 0.8,
        textTransform: 'uppercase',
        color: theme.palette.colors.greyDark,
    },
    groupDot: {
        width: 8,
        height: 8,
        borderRadius: '50%',
        marginRight: 8,
    },
    item: {
        padding: '8px 16px',
        cursor: 'pointer',
        borderLeft: '3px solid transparent',
    },
    itemActive: {
        backgroundColor: theme.palette.colors.table.hover,
        borderLeftColor: theme.palette.secondary.main,
    },
    itemIcon: {
        minWidth: 36,
        color: theme.palette.colors.greyDark,
    },
    itemTitle: {
        fontWeight: 600,
        fontSize: 14,
    },
    itemSubtitle: {
        fontSize: 12,
        color: theme.palette.colors.greyDark,
    },
    empty: {
        padding: '24px 16px',
        textAlign: 'center',
        color: theme.palette.colors.greyDark,
        fontSize: 14,
    },
    footer: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 12,
        justifyContent: 'space-between',
        padding: '8px 16px',
        borderTop: `1px solid ${theme.palette.colors.table.separator}`,
        backgroundColor: theme.palette.colors.grey,
        fontSize: 11,
        color: theme.palette.colors.greyDark,
    },
    key: {
        display: 'inline-block',
        padding: '1px 5px',
        margin: '0 2px',
        borderRadius: 4,
        border: `1px solid ${theme.palette.colors.greySeparator}`,
        backgroundColor: theme.palette.colors.white,
        fontFamily: 'monospace',
    },
});

export default style;
